import React from 'react'

export default class IconsDnDInput extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
            >
                <path
                    d='M1.86661 5.6001H9.86661'
                    stroke='black'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M13.3666 8.2666H2.63327C2.20986 8.2666 1.86661 8.56508 1.86661 8.93327V10.2666C1.86661 10.6348 2.20986 10.9333 2.63327 10.9333H13.3666C13.79 10.9333 14.1333 10.6348 14.1333 10.2666V8.93327C14.1333 8.56508 13.79 8.2666 13.3666 8.2666Z'
                    stroke='black'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
